import { currencyCodeSuffix } from '../../utils/money';
import { InvoiceType, PaymentAttemptStatus } from '../../../__generated__/graphql';

const LABELS: Partial<Record<InvoiceType, string>> = {
  [InvoiceType.ExtraMileage]: 'Extra mileage',
  [InvoiceType.DamageCharge]: 'Damage',
  [InvoiceType.LateFee]: 'Late return',
  [InvoiceType.SmokingFee]: 'Smoking fee',
  [InvoiceType.CleaningFee]: 'Cleaning fee',
  [InvoiceType.AdditionalDriverFee]: 'Additional driver',
  [InvoiceType.YoungsterFeeCharge]: 'Young driver fee',
  [InvoiceType.TollFeeCharge]: 'Tolls',
  [InvoiceType.TicketFeeCharge]: 'Parking or traffic ticket',
  [InvoiceType.FuelFeeCharge]: 'Fuel',
  [InvoiceType.OtherFeeCharge]: 'Post-trip charges',
};

/** The guest-facing name of a post-trip charge. */
export function postTripChargeLabel(type: InvoiceType): string {
  return LABELS[type] ?? 'Trip charge';
}

/** The fields of `payOutstandingInvoice` the modal acts on. */
export interface InvoicePaymentOutcome {
  status: PaymentAttemptStatus;
  paymentIntentId?: string | null;
  clientSecret?: string | null;
  errorMessage?: string | null;
}

export type InvoicePaymentStep =
  | { kind: 'paid' }
  | { kind: 'authenticate'; clientSecret: string; paymentIntentId: string }
  | { kind: 'failed'; message: string };

const GENERIC_FAILURE = 'The payment did not go through. Please try another card.';

/** Routes the server's answer: paid, a bank check to complete, or a readable error. */
export function nextInvoicePaymentStep(result: InvoicePaymentOutcome): InvoicePaymentStep {
  if (result.status === PaymentAttemptStatus.Succeeded) return { kind: 'paid' };
  if (
    result.status === PaymentAttemptStatus.RequiresAction &&
    result.clientSecret &&
    result.paymentIntentId
  ) {
    return {
      kind: 'authenticate',
      clientSecret: result.clientSecret,
      paymentIntentId: result.paymentIntentId,
    };
  }
  return { kind: 'failed', message: result.errorMessage || GENERIC_FAILURE };
}

/** "$42.50" from the API's decimal amount; "$42.50 CAD" for a CAD trip (spec 028 D14). */
export function formatChargeAmount(amount: number | string, currency?: string | null): string {
  return `$${Number(amount).toFixed(2)}${currencyCodeSuffix(currency)}`;
}
